import React from 'react';
import { useDispatch } from 'react-redux';
import { playSong } from '../../common/actions/common.actions';
import { useTranslation } from 'react-i18next';
import { RiDeleteBin6Line } from 'react-icons/ri';

const Card = ({ number, team1, team2, odd, choosen, handleRemoveCard, match, normalColor = true }) => {
  const dispatch = useDispatch();
  const { i18n } = useTranslation();

  const homeTeamName = i18n.language === 'en' ? team1 : match.homeTeamMyan;
  const awayTeamName = i18n.language === 'en' ? team2 : match.awayTeamMyan;

  const handleSongClick = () => {
    dispatch(playSong());
  };

  const removeCard = () => {
    handleSongClick();
    handleRemoveCard(match.rapidEventId);
  };

  return (
    <div className={`relative w-[95%]  p-2 
      ${normalColor 
        ? 'border-b border-emerald-200/70' 
        : 'bg-white/20 border-b border-emerald-200/50'
      }`}>

      {/* Delete Button */}
      

      <div className="grid grid-cols-12 gap-4 items-center text-sm text-gray-800 dark:text-white">
        {/* Match Number */}
        <div className="col-span-1 text-md font-bold text-wback">
          {number}
        </div>

        {/* Team Names */}
        <div className="col-span-5 space-y-1 text-wback">
          <div className={`${match.overId === match.homeId ? '' : ''}`}>
            {homeTeamName}
          </div>
          <div className={`${match.overId === match.awayId ? '' : ''}`}>
            {awayTeamName}
          </div>
        </div>

        {/* Odd */}
        <div className="col-span-2 text-center">
          <div className="inline-block px-1 py-1 text-xs rounded-full bg-yellow-100 text-yellow-800 dark:bg-yellow-600/20 dark:text-yellow-300 font-semibold">
            {odd}
          </div>
        </div>

        {/* Chosen Team */}
        <div className="col-span-4 flex justify-end">
          <div className="text-xs px-3 py-1 bg-purple-100 text-purple-800 dark:bg-purple-600/20 dark:text-purple-300 rounded-full font-medium">
            {choosen === 'home' ? homeTeamName : choosen === 'away' ? awayTeamName : choosen}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Card;
